import { Component, EventEmitter, Input, Output } from '@angular/core';
import { InvoiceFilterBar, MonthRange } from '../invoice-filter-bar/invoice-filter-bar';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-invoice-header',
  imports: [CommonModule, FormsModule, TranslatePipe, InvoiceFilterBar],
  templateUrl: './invoice-header.html',
  styleUrl: './invoice-header.scss',
})
export class InvoiceHeader {
  @Input()  searchQuery  = '';
  @Input()  eventTypes: string[]    = [];
  @Input()  invoiceSiteNames: string[] = [];
  @Output() searchQueryChange     = new EventEmitter<string>();
  @Output() monthRangeChange      = new EventEmitter<MonthRange>();
  @Output() siteFilterChange      = new EventEmitter<string[]>();
  @Output() eventTypeFilterChange = new EventEmitter<string[]>();
}
